// extracted by mini-css-extract-plugin
export default {"root":"EditModalColumn_root__uqxpL","li":"EditModalColumn_li__jmrNP","label":"EditModalColumn_label__yPACw","value":"EditModalColumn_value__v2z5t"};